import { ApiClient } from "@common/network/client";
import { IApiClient } from "@common/network/interfaces";
import { getConfig } from "@config/index";
import {
  IFetchOrganizationActionPayload,
  IOrganizationData,
  IRegisterOrganizationActionPayload,
} from "@common/redux/profile/actions";

import {
  fetchUserProfiles,
  registerOrganization,
  updateProfileData,
} from "../apis/urls";

const ENDPOINTS = {
  fetchUserProfiles: () => fetchUserProfiles,
  updateProfileData: () => updateProfileData,
  registerOrganization: () => registerOrganization,
};
class ProfileRepository {
  private apiClient: IApiClient;
  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }

  public fetchUserProfiles = async (data: any) => {
    const params = {
      pageNumber: data.Page,
      pageSize: data.limit,
    };
    const result = await this.apiClient.get(
      ENDPOINTS.fetchUserProfiles(),
      params
    );
    return result;
  };

  public updateProfileData = async (data: any) => {
    const payload = data;
    const result = await this.apiClient.put(
      ENDPOINTS.updateProfileData(),
      payload
    );
    return result;
  };

  public createProfileData = async (data: any) => {
    const result = {
      id: data.id,
      email: data.email,
      name: data.name,
      mobile: data.mobile,
      pictureUrl: data.pictureUrl,
      gender: data.gender,
      dob: data.dob,
      addresses: data.addresses,
    };
    return result;
  };

  public registerOrganization = async (
    data: IRegisterOrganizationActionPayload
  ) => {
    const result = await this.apiClient.post(
      ENDPOINTS.registerOrganization(),
      data,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );

    return { data: result.data };
  };

  public fetchOrganizationData = async (
    params: IFetchOrganizationActionPayload
  ) => {
    const result = await this.apiClient.get(
      ENDPOINTS.registerOrganization(),
      params,
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public updateOrganization = async (data: IOrganizationData) => {
    const result = await this.apiClient.put(
      ENDPOINTS.registerOrganization(),
      data,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return { data: result.data };
  };
}

const profileRepository = new ProfileRepository(ApiClient);

export { profileRepository as ProfileRepository };
